module.exports = __webpack_public_path__ + "static/media/48392413_2308759145865930_7411442793437986816_o-thumb.48b24e65.jpg";